// extracted by mini-css-extract-plugin
export default {"wrapper":"HeroBanner_wrapper__048Fh","hero":"HeroBanner_hero__GQ5OB","content":"HeroBanner_content__98dok","heading":"HeroBanner_heading__kn3Wr","blurb":"HeroBanner_blurb__ky1xI"};